export const pizzaBorder =[
    { key: 'bordesQueso',
      value: {
        personal: 2500,
        pequeña: 3500,
        mediana: 4500,
        grande: 5500,
      },
      text: 'Borde de Queso' ,
      borderImg:require('../img/imgBordePizzas/bordeQueso.jpg'),
      description:'Delicioso borde de queso, para darle ese toque perfecto al final de cada pizza'
    },
    { key: 'bordesQuesoBocadilloPiña', 
     value: {
        personal: 4000,
        pequeña: 5500,
        mediana: 6500,
        grande: 7500,
      },
      text: 'Borde de Queso con Bocadillo' ,
      borderImg:require('../img/imgBordePizzas/bordeQuesoBocadillo.jpg'),
      description:'Delicioso borde de queso con bocadillo, para darle ese toque perfecto al final de cada pizza'

    },
    { key: 'bordesQuesoPiña', 
     value: {
        personal: 4000,
        pequeña: 5500,
        mediana: 6500,
        grande: 7500,
      },
      text: 'Borde de Queso con Piña' ,
      borderImg:require('../img/imgBordePizzas/bordePiña.jpg'),
      description:'Delicioso borde de queso con piña, para darle ese toque perfecto al final de cada pizza'
    },
    ]
